module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('my-panel', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d13dcca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Admin.vue
// module id = 1688
// module chunks = 2